import React, { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { getSynonym } from "../Utils";

export const CustomFormattedMessage = memo(
  ({ id, defaultMessage, values, tagName }) => {
    const dynamicLabels = useSelector((state) => state.layout.dynamicLabels);

    if (!id) {
      console.warn("Missing `id` prop for Formatted Message");
      return null;
    }

    let result = getSynonym({ dynamicLabels, id });

    const formattedId = result || id;

    const formattedMessage = result || defaultMessage;

    if (id === "Main Teams") {
      console.log(id, defaultMessage, formattedId, formattedMessage);
    }
    return (
      <FormattedMessage
        id={formattedId}
        defaultMessage={formattedMessage}
        values={values}
        tagName={tagName}
      />
    );
  }
);

CustomFormattedMessage.displayName = "CustomFormattedMessage";

CustomFormattedMessage.propTypes = {
  id: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string,
  values: PropTypes.object,
  tagName: PropTypes.string,
  fallback: PropTypes.string, // Extra optional fallback message
};

CustomFormattedMessage.defaultProps = {
  defaultMessage: "n/a",
  values: {},
  tagName: undefined,
  fallback: "", // You can set a global fallback message here
};
